import React from 'react';
import ReactDOM from 'react-dom';

import { useEnableNewHotkeySystem } from '../../../../feature-flags/hooks/use-enable-new-hotkey-system';
import { GlobalEventListenerRoot } from '../../global-event-listener/root';
import { useArrowClass } from '../../../hooks/tooltip/use-arrow-class';
import { usePositioning } from '../../../hooks/tooltip/use-positioning';
import { PopoverContent } from './index';

const popoverContentType = (<PopoverContent />).type;

export const PopoverContentChild = React.forwardRef(({ children, containerId, isInteractable, position: positionProp }, ref) => {
  const isNewHotkeySystemEnabled = useEnableNewHotkeySystem();
  const { position, ref: popoverRef, style } = usePositioning(ref, positionProp);

  const arrowClass = useArrowClass(position);

  const popoverContentChild = React.Children.toArray(children).find((child) => child.type === popoverContentType);

  const popoverContentProps = {
    arrowClass,
    position,
    ref: popoverRef,
    style,
  };

  const popoverContent = React.cloneElement(popoverContentChild, popoverContentProps);

  if (isInteractable) {
    const portalContent = isNewHotkeySystemEnabled ? popoverContent : <GlobalEventListenerRoot>{popoverContent}</GlobalEventListenerRoot>;
    return ReactDOM.createPortal(portalContent, global.document.getElementById(containerId));
  }
  return ReactDOM.createPortal(popoverContent, global.document.getElementById(containerId));
});
